module.exports = __webpack_public_path__ + "img/RECREATION_SPEEDQUIZ.00a59423.jpg";